/* eslint-disable */
import { sortBy } from "lodash"


export enum SynergyTrait {
    stealsAmber = "stealsAmber",
    capturesAmber = "capturesAmber",
    increasesKeyCost = "increasesKeyCost",
    scalingAmberControl = "scalingAmberControl",
    exalt = "exalt",
    putsAmberOnTarget = "putsAmberOnTarget",
    forgesKeys = "forgesKeys",
    forgesKeysWithoutAember = "forgesKeysWithoutAember",
    preventsForging = "preventsForging",
    massCapturedAmberRemoval = "massCapturedAmberRemoval",
    destroys = "destroys",
    dealsDamage = "dealsDamage",
    boardClear = "boardClear",
    damagesMultiple = "damagesMultiple",
    exhausts = "exhausts",
    archives = "archives",
    archivesRandom = "archivesRandom",
    drawsCards = "drawsCards",
    increasesHandSize = "increasesHandSize",
    playsCards = "playsCards",
    shufflesDiscard = "shufflesDiscard",
    mills = "mills",
    revealsTopDeck = "revealsTopDeck",
    discardsCards = "discardsCards",
    purges = "purges",
    chains = "chains",
    reduces_R_HandSize = "reduces_R_HandSize",
    revealsHand = "revealsHand",
    controlsHouseChoice = "controlsHouseChoice",
    returns_R_ToHand = "returns_R_ToHand",
    shuffles_R_IntoDeck = "shuffles_R_IntoDeck",
    replays = "replays",
    puts_R_OnBottomOfDeck = "puts_R_OnBottomOfDeck",
    uses = "uses",
    readies = "readies",
    causesFighting = "causesFighting",
    causesReaping = "causesReaping",
    goodReap = "goodReap",
    goodAction = "goodAction",
    goodPlay = "goodPlay",
    goodFight = "goodFight",
    goodDestroyed = "goodDestroyed",
    protectsCreatures = "protectsCreatures",
    increasesCreaturePower = "increasesCreaturePower",
    addsPowerTokens = "addsPowerTokens",
    moves = "moves",
    any = "any",
    makesTokens = "makesTokens",
    scrapValue = "scrapValue",
    preventsDamage = "preventsDamage",
    alpha = "alpha",
    omega = "omega",
    raisesTide = "raisesTide",
    lowersTide = "lowersTide",
    replaysSelf = "replaysSelf",
    dangerousRandomPlay = "dangerousRandomPlay",
    prophecy = "prophecy",
    earlyResolution = "earlyResolution",
    lateResolution = "lateResolution",
    fate = "fate",
    enhanced = "enhanced",
    enhancedHouses = "enhancedHouses",
    selfEnhanced = "selfEnhanced",
    bonusAmber = "bonusAmber",
    bonusDraw = "bonusDraw",
    bonusDamage = "bonusDamage",
    bonusCapture = "bonusCapture",
    bonusDiscard = "bonusDiscard",
    bonusPower = "bonusPower",
    expectedAember = "expectedAember",
    capturedAmber = "capturedAmber",
    targettedCapturedAmber = "targettedCapturedAmber",
    creatureCount = "creatureCount",
    haunted = "haunted",
    tokenCount = "tokenCount",
    totalCreaturePower = "totalCreaturePower",
    totalArmor = "totalArmor",
    propheticOdds = "propheticOdds",
    card = "card",
    highValue = "highValue",
    playsFromOtherHouse = "playsFromOtherHouse",
    hasMars = "hasMars",
    returns_R_FromDiscard = "returns_R_FromDiscard",
    highExpectedAmber = "highExpectedAmber",
    lowExpectedAmber = "lowExpectedAmber",
    removesCapturedAmber = "removesCapturedAmber",
    highTotalArmor = "highTotalArmor",
    highTotalCreaturePower = "highTotalCreaturePower",
    lowTotalCreaturePower = "lowTotalCreaturePower",
    highCreatureCount = "highCreatureCount",
    lowCreatureCount = "lowCreatureCount",
    upgradeCount = "upgradeCount",
    highArtifactCount = "highArtifactCount",
    lowArtifactCount = "lowArtifactCount",
    elusive = "elusive",
    skirmish = "skirmish",
    poison = "poison",
    deploy = "deploy",
    ward = "ward",
    preventsFighting = "preventsFighting",
    protectsFromEffects = "protectsFromEffects",
    preventsRemoval = "preventsRemoval",
    heals = "heals",
    distributableDamage = "distributableDamage",
    stuns = "stuns",
    sacrificesCreatures = "sacrificesCreatures",
    discardsFromDeck = "discardsFromDeck",
    addsArmor = "addsArmor",
    usableArtifact = "usableArtifact",
    staticArtifact = "staticArtifact",
    reorderDeck = "reorderDeck",
    revealsBottomDeck = "revealsBottomDeck",
    controls = "controls",
    inAllHouses = "inAllHouses",
    regenerates = "regenerates",
}

export class SynergyTraitUtils {
    static readonly values = [SynergyTrait.stealsAmber, SynergyTrait.capturesAmber, SynergyTrait.increasesKeyCost, SynergyTrait.scalingAmberControl, SynergyTrait.exalt, SynergyTrait.putsAmberOnTarget, SynergyTrait.forgesKeys, SynergyTrait.forgesKeysWithoutAember, SynergyTrait.preventsForging, SynergyTrait.massCapturedAmberRemoval, SynergyTrait.destroys, SynergyTrait.dealsDamage, SynergyTrait.boardClear, SynergyTrait.damagesMultiple, SynergyTrait.exhausts, SynergyTrait.archives, SynergyTrait.archivesRandom, SynergyTrait.drawsCards, SynergyTrait.increasesHandSize, SynergyTrait.playsCards, SynergyTrait.shufflesDiscard, SynergyTrait.mills, SynergyTrait.revealsTopDeck, SynergyTrait.discardsCards, SynergyTrait.purges, SynergyTrait.chains, SynergyTrait.reduces_R_HandSize, SynergyTrait.revealsHand, SynergyTrait.controlsHouseChoice, SynergyTrait.returns_R_ToHand, SynergyTrait.shuffles_R_IntoDeck, SynergyTrait.replays, SynergyTrait.puts_R_OnBottomOfDeck, SynergyTrait.uses, SynergyTrait.readies, SynergyTrait.causesFighting, SynergyTrait.causesReaping, SynergyTrait.goodReap, SynergyTrait.goodAction, SynergyTrait.goodPlay, SynergyTrait.goodFight, SynergyTrait.goodDestroyed, SynergyTrait.protectsCreatures, SynergyTrait.increasesCreaturePower, SynergyTrait.addsPowerTokens, SynergyTrait.moves, SynergyTrait.any, SynergyTrait.makesTokens, SynergyTrait.scrapValue, SynergyTrait.preventsDamage, SynergyTrait.alpha, SynergyTrait.omega, SynergyTrait.raisesTide, SynergyTrait.lowersTide, SynergyTrait.replaysSelf, SynergyTrait.dangerousRandomPlay, SynergyTrait.prophecy, SynergyTrait.earlyResolution, SynergyTrait.lateResolution, SynergyTrait.fate, SynergyTrait.enhanced, SynergyTrait.enhancedHouses, SynergyTrait.selfEnhanced, SynergyTrait.bonusAmber, SynergyTrait.bonusDraw, SynergyTrait.bonusDamage, SynergyTrait.bonusCapture, SynergyTrait.bonusDiscard, SynergyTrait.bonusPower, SynergyTrait.expectedAember, SynergyTrait.capturedAmber, SynergyTrait.targettedCapturedAmber, SynergyTrait.creatureCount, SynergyTrait.haunted, SynergyTrait.tokenCount, SynergyTrait.totalCreaturePower, SynergyTrait.totalArmor, SynergyTrait.propheticOdds, SynergyTrait.card, SynergyTrait.highValue, SynergyTrait.playsFromOtherHouse, SynergyTrait.hasMars, SynergyTrait.returns_R_FromDiscard, SynergyTrait.highExpectedAmber, SynergyTrait.lowExpectedAmber, SynergyTrait.removesCapturedAmber, SynergyTrait.highTotalArmor, SynergyTrait.highTotalCreaturePower, SynergyTrait.lowTotalCreaturePower, SynergyTrait.highCreatureCount, SynergyTrait.lowCreatureCount, SynergyTrait.upgradeCount, SynergyTrait.highArtifactCount, SynergyTrait.lowArtifactCount, SynergyTrait.elusive, SynergyTrait.skirmish, SynergyTrait.poison, SynergyTrait.deploy, SynergyTrait.ward, SynergyTrait.preventsFighting, SynergyTrait.protectsFromEffects, SynergyTrait.preventsRemoval, SynergyTrait.heals, SynergyTrait.distributableDamage, SynergyTrait.stuns, SynergyTrait.sacrificesCreatures, SynergyTrait.discardsFromDeck, SynergyTrait.addsArmor, SynergyTrait.usableArtifact, SynergyTrait.staticArtifact, SynergyTrait.reorderDeck, SynergyTrait.revealsBottomDeck, SynergyTrait.controls, SynergyTrait.inAllHouses, SynergyTrait.regenerates]
    static valueOf = (value: string) => SynergyTraitUtils.values.find(enumValue => enumValue === value)
    static sort = (value: SynergyTrait[]) => sortBy(value, expansion => SynergyTraitUtils.values.indexOf(expansion))
}